/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UxwidgetconfigWc } from '../../models/uxwidgetconfig-wc';

export interface GetWidgetConfigurationDetails$Params {
  wcid?: number;
}

export function getWidgetConfigurationDetails(http: HttpClient, rootUrl: string, params?: GetWidgetConfigurationDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UxwidgetconfigWc>>> {
  const rb = new RequestBuilder(rootUrl, getWidgetConfigurationDetails.PATH, 'get');
  if (params) {
    rb.query('wcid', params.wcid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UxwidgetconfigWc>>;
    })
  );
}

getWidgetConfigurationDetails.PATH = '/api/DashboardManagement/GetWidgetConfigurationDetails';
